import { ContentGapsPage } from "@/components/dashboard/ContentGapsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/dashboard/content-gaps")({
  component: ContentGapsPage,
});
